import type { UseFilterButtonProps } from '@pearlconvert/ui/components/button/button.types'

import { useCallback, useEffect, useState } from 'react'

import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export const useFilterButton = ({ onClick }: UseFilterButtonProps) => {
  const [expanded, setExpanded] = useState(false)
  const { hash } = useHash()

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick?.(event)
      setExpanded(!expanded)
    },
    [expanded, onClick]
  )

  useEffect(() => {
    if (!hash.includes('filters')) {
      setExpanded(false)
    }
  }, [hash])

  return {
    expanded,
    handleClick,
  }
}
